import { useEventsPublisher } from 'event-bus';
import { Person } from './Types';
import { useBackendApi } from './backendApi';

export const CONTACTS_MASS_ADDED_TO_CLIENT_APP = 'CONTACTS_MASS_ADDED_TO_CLIENT_APP';

export interface ContactsMassAddedToClientAppEvent {
  ids: number[];
}

export function isPersonCanBeAddedToClientApp(person: Person) {
  return person.serviceProvidersIds.length > 0;
}

export function usePeopleMassAddToClientAppService() {

  const nekstApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const massAddToClientApp = async (ids: number[]) => {
    await nekstApi.put('/people/bulk/addtoclientapp', {
      ids,
    });

    eventsPublisher.publish(CONTACTS_MASS_ADDED_TO_CLIENT_APP, { ids } as ContactsMassAddedToClientAppEvent);
  };

  return {
    massAddToClientApp,
  };
}
